import { logo } from './logo';
import { linearSet as icons } from '@coreui/icons-pro';
import { flagSet as flags } from '@coreui/icons-pro';

export const iconsSet = Object.assign(
  {},
  { logo },
  icons,
  flags
)